import { LoggerAdapter } from './logger/internal/LoggerAdapter';
import { Logger, LoggerLevel } from './logger/Logger';
import { HttpClientAdapter } from './http/internal/HttpClientAdapter';
import { RequestBuilder } from './http/internal/RequestAdapter';
import { LocalStorageProvider, LocalStorage } from './storage/internal/LocalStorageProvider';
import { SpeedAnalyser } from './speedtest/SpeedAnalyser';

import { Builder } from './http/HttpRequest';
import { HttpClient } from './http/HttpClient';
import { HttpServerSentEventClientAdapter } from './http/internal/HttpServerSentEventClientAdapter';
import { HttpServerSentEventClient } from './fl-foundation';

export const Factory = {
  createlogger(logLevel?: LoggerLevel, tag?: string): Logger {
    return new LoggerAdapter(logLevel, tag);
  },
  createHttpClient<RequestBody, ResponseBody>(): HttpClient<RequestBody, ResponseBody> {
    return new HttpClientAdapter<RequestBody, ResponseBody>();
  },
  createRequestBuilder<RequestBody>(): Builder<RequestBody> {
    return new RequestBuilder<RequestBody>();
  },
  createKeyValueStore<T>(storeName: string, storage: LocalStorage): LocalStorageProvider<T> {
    return new LocalStorageProvider(storeName, storage);
  },
  createHttpServerSentEventClient(httpURL: string, initData?: EventSourceInit): HttpServerSentEventClient {
    return new HttpServerSentEventClientAdapter(httpURL, initData);
  },
  createSpeedAnalyser(): SpeedAnalyser {
    return new SpeedAnalyser();
  },
};
